import { CommandUpdateFavicon } from "messages";

let originalFaviconConfig: {
  light: string;
  dark: string;
  default: string;
} | null = null;

const initializeOriginalFavicons = () => {
  if (originalFaviconConfig) return;

  const lightFavicon = document.querySelector(
    'link[rel="icon"][media="(prefers-color-scheme: light)"]'
  ) as HTMLLinkElement;
  const darkFavicon = document.querySelector(
    'link[rel="icon"][media="(prefers-color-scheme: dark)"]'
  ) as HTMLLinkElement;
  const defaultFavicon = document.querySelector(
    'link[rel="icon"]:not([media])'
  ) as HTMLLinkElement;

  originalFaviconConfig = {
    light: lightFavicon?.href || "/favicon.ico",
    dark: darkFavicon?.href || "/favicon_dark.ico",
    default: defaultFavicon?.href || "/favicon.ico",
  };
};

const updateFavicon = (url: string) => {
  const faviconLinks = document.querySelectorAll('link[rel="icon"]');
  faviconLinks.forEach((link) => {
    (link as HTMLLinkElement).href = url;
  });
};

const resetFavicon = () => {
  if (!originalFaviconConfig) return;

  const lightFavicon = document.querySelector(
    'link[rel="icon"][media="(prefers-color-scheme: light)"]'
  ) as HTMLLinkElement;
  const darkFavicon = document.querySelector(
    'link[rel="icon"][media="(prefers-color-scheme: dark)"]'
  ) as HTMLLinkElement;
  const defaultFavicon = document.querySelector(
    'link[rel="icon"]:not([media])'
  ) as HTMLLinkElement;

  if (lightFavicon) lightFavicon.href = originalFaviconConfig.light;
  if (darkFavicon) darkFavicon.href = originalFaviconConfig.dark;
  if (defaultFavicon) defaultFavicon.href = originalFaviconConfig.default;
};

const handleUpdateFavicon = (message: CommandUpdateFavicon) => {
  initializeOriginalFavicons();

  if ("reset" in message.payload && message.payload.reset) {
    resetFavicon();
  } else if ("url" in message.payload) {
    updateFavicon(message.payload.url);
  }
};

export { handleUpdateFavicon };
